<app-dialog [(isOpen)]="isOpen">
  <app-view
    [direction]="ViewDirection.COLUMN"
    [align]="ViewAlign.CENTER"
    [gap]="contentGap"
  >
    <app-view
      *ngIf="title || subTitle"
      [direction]="ViewDirection.COLUMN"
      [gap]="headerGap"
      [align]="headerPlacement"
    >
      <app-text
        *ngIf="title"
        [type]="TextType.TITLE"
        [size]="TextSize.TITLE_3"
        [height]="TextHeight.BODY_4"
        [weight]="TextWeight.BOLD"
        [color]="TextColor.NEUTRAL_8"
        [align]="titleAlignment"
        >{{ title }}</app-text
      >
      <app-text
        *ngIf="subTitle"
        [size]="TextSize.BODY_4"
        [height]="TextHeight.BODY_2"
        [color]="TextColor.NEUTRAL_6"
        [weight]="TextWeight.REGULAR"
        >{{ subTitle }}</app-text
      >
    </app-view>
    <ng-content></ng-content>
    <app-view
      [direction]="ViewDirection.ROW"
      [align]="buttonPlacement"
      [justify]="buttonPlacement"
      [gap]="ViewSpacing.MEDIUM"
    >
      <app-button
        *ngIf="primaryText"
        [type]="ButtonType.PRIMARY"
        [disabled]="primaryDisabled"
        (handleClick)="handlePrimaryButtonPass()"
        [size]="buttonSize"
        >{{ primaryText }}</app-button
      >
      <app-button
        *ngIf="secondaryText"
        [type]="secondaryButtonType"
        (handleClick)="handleSecondaryButtonPass()"
        [size]="buttonSize"
        >{{ secondaryText }}</app-button
      >
    </app-view>
  </app-view>
</app-dialog>
